// src/auth/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute() {
    const { ready, isAuthed } = useAuth();

    if (!ready) return null;
    if (!isAuthed) return <Navigate to="/login" replace />;
    return <Outlet />;
}
